import React, { useState } from "react";

import SelectMonth from "../../components/selectMonth";
import ActivityTable from "../../components/activityTable";

const Activity = ({ user }) => {
  const [date, setDate] = useState(null);
  return (
    <div className="w-screen md:w-full">
      <div className="flex flex-wrap gap-5 p-2 md:!px-8">
        <SelectMonth start={-11} indexDefaultValue={11} value={date} onChange={(e) => setDate(e.target.value)} showArrows />
      </div>
      {date && user && <ActivityTable date={new Date(date)} user={user} />}
    </div>
  );
};

export default Activity;
